import React from 'react';
import About from '../components/About';
import Recognition from '../components/Recognition';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <div>
      <SEO 
        title="About Us | 17+ Years of Excellence | Rubicon Finservices"
        description="Learn about Rubicon Finservices - AMFI Registered Mutual Fund Distributor with ARN: 102867. 17+ years of experience, multiple awards, ₹100 Cr+ AUM, and 500+ satisfied investors."
        keywords="about rubicon finservices, AMFI registered distributor, mutual fund awards, financial advisory experience, wealth management Kolkata, investment expertise"
        ogImage="https://customer-assets.emergentagent.com/job_rubicon-funds/artifacts/7akuxub4_LOGO.png"
      />
      <About />
      <Recognition />
    </div>
  );
};

export default AboutPage;
